import React from 'react';
import ApiCard from '../../../components/ui/ApiCard.tsx'; // Ajusta la ruta según tu carpeta

const CommerceApiContent = () => {
  return (
    <div className="max-w-none mx-auto animate-fadeIn overflow-y-auto custom-scrollbar px-6 py-4 h-full">
      <h2 className="text-3xl font-bold mb-8 text-white/90">Commerce Automation APIs</h2>

      {/* API 1: Document Flow */}
      <ApiCard
        method="POST"
        endpoint="/document-flow/v1/search"
        description="Esta API permite rastrear el flujo de documentos (PO, Receipt, Invoice) dentro de la red de Ariba para un realm específico."
        payload={{
          documentId: "PO12345",
          realm: "my-company-T",
          type: "order"
        }}
      />

      {/* API 2: Invoice Extract (Ejemplo de lo fácil que es agregar otra) */}
      <ApiCard
        method="GET"
        endpoint="/invoice-extract/v2/invoices?status=approved"
        description="Obtiene una lista de facturas aprobadas pendientes de extracción para el sistema ERP."
      />


      {/* API 3: Purchase Order Async */}
      <ApiCard
        method="PUT"
        endpoint="/purchase-orders/v1/status-update"
        description="Actualiza el estado de una orden de compra de forma asíncrona desde un sistema externo."
        payload={{
          orderId: "EP1002",
          status: "Confirmed",
          comments: "Recibido en SAP S/4HANA"
        }}
      />


      {/* API 4: Invoice Extract (Ejemplo de lo fácil que es agregar otra) */}
      <ApiCard
        method="DELETE"
        endpoint="/invoice-extract/v2/invoices?status=delete"
        description="Eliminar facturas "
      />

    </div>
  );
};

export default CommerceApiContent;